<div *ngIf="title && type"
     class="row no-gutters px-3 py-3 mb-orderdetails-info-wrapper"
     data-cy="mb-orderdetails-info-wrapper">
  <div [ngClass]="[isEditable && linkToEditComponent ? 'col-9' : 'col-12', 'mb-orderdetails-info-title']"
       data-cy="mb-orderdetails-info-title">
    {{ title | mbTranslate }}
  </div>
  <div *ngIf="isEditable && linkToEditComponent"
       class="col-3 text-right"
       data-cy="mb-orderdetails-info-edit">
    <a [routerLink]="linkToEditComponent"
       class="cursor-pointer">
      <img src="../../../../../../assets/icons/svg/edit_pencil.svg"
           alt="Edit information"
           title="Edit information"
           aria-label="Edit information"
           data-cy="mb-orderdetails-info-edit-icon">
    </a>
  </div>
  <div class="col-12 mb-orderdetails-info"
       data-cy="mb-orderdetails-info">

    <ng-container *ngIf="type === infoTypes?.CONTACT_DETAILS && data">
      <div>{{data.title?.name}} {{data.academicDegree?.name}}</div>
      <div>{{data.firstName}} {{data.lastName}}</div>
      <div>{{data.email}}</div>
      <div>{{data.phoneNumber}}</div>
      <div>{{data.jobTitle?.name}}</div>
      <div>{{data.customerNumber}}</div>
    </ng-container>

    <ng-container *ngIf="type === infoTypes?.ADDRESS && data">
      <div *ngIf="data.companyName">{{data?.companyName}}</div>
      <div *ngIf="data.institute">{{data?.institute}}</div>
      <div *ngIf="data.department">{{data?.department}}</div>
      <div *ngIf="data.lab">{{data?.lab}}</div>
      <div *ngIf="data.building">{{data?.building}}</div>
      <div *ngIf="data.streetInformation">{{data?.streetInformation}}</div>

      <ng-container *ngIf="formRegion === checkoutRegions?.EU">
        <div *ngIf="data.postalCode || data.town"> {{data?.postalCode}} {{data?.town}}</div>
      </ng-container>

      <ng-container *ngIf="(formRegion === checkoutRegions?.US || formRegion === checkoutRegions?.AU)">
        <div *ngIf="data.town || data.postalCode || data.region">{{data?.town}} {{data?.region?.name}}, {{data?.postalCode}}</div>
      </ng-container>

      <ng-container *ngIf="formRegion === checkoutRegions?.UN">
        <div *ngIf="data.town || data.postalCode">{{data?.town}} {{data?.postalCode}}</div>
      </ng-container>

      <div *ngIf="data.country">{{data?.country?.name}}</div>

      <div class="mt-2" *ngIf="data.vatId && formRegion === checkoutRegions.EU">
        {{ vatIdLabelKey | mbTranslate }}: {{ data?.vatId }}
      </div>

      <div class="mt-2" *ngIf="hasSalesTaxExemption && formRegion === checkoutRegions.US">
        {{ salesTaxLabelKey | mbTranslate }} {{ (data?.taxExempt ? 'mbcommon.yes' : 'mbcommon.no') | mbTranslate}}
      </div>
    </ng-container>

    <ng-container *ngIf="type === infoTypes?.SHIPMENT_METHOD">
      {{ 'review.standardDelivery' | mbTranslate }}
    </ng-container>

    <ng-container *ngIf="type === infoTypes?.PAYMENT_METHOD && data">
      <div *ngIf="data.poPaymentMode">
        {{ 'review.invoice' | mbTranslate }}
      </div>
      <div *ngIf="!data.poPaymentMode && data?.code === constants.CREDIT_CARD_CODE">
        {{ 'review.creditCard' | mbTranslate }}
      </div>
    </ng-container>

    <ng-container *ngIf="type === infoTypes?.PAYMENT_ADDITIONAL_INFO">
      <div *ngIf="!!data.poNumber">
        {{ poNumberLabelKey | mbTranslate }}
        <div>{{data.poNumber}}</div>
      </div>
    </ng-container>

    <ng-container *ngIf="type === infoTypes?.ORDER_STATUS && data">
      <div *ngIf="data">
        <span>
          {{data}}
        </span>
      </div>
    </ng-container>

    <ng-container *ngIf="type === infoTypes?.NOTES && data">
      <span [innerHTML]="data"></span>
    </ng-container>
  </div>
</div>
